/**
 * listing_view override: migrated Folders/Collections carry their authored
 * Volto blocks (title + search/listing tables), but Volto resolves their view
 * by FTI layout (`listing_view`), which renders folder children and ignores
 * blocks. Render the blocks when they exist; otherwise fall back to the stock
 * folder listing.
 */
import React from 'react';
import DefaultView from '@plone/volto/components/theme/View/DefaultView';
import ListingView from '@plone/volto/components/theme/View/ListingView';
import { hasBlocksData } from '@plone/volto/helpers';

const BlocksAwareListingView = (props) =>
  hasBlocksData(props.content) ? (
    <DefaultView {...props} />
  ) : (
    <ListingView {...props} />
  );

export default BlocksAwareListingView;
